// Single source of truth for enums shared with the backend.
// Mirrors betright-backend/src/utils/Enums.ts. Keep in sync when the
// backend canonical source changes.
//
// Names that diverge from backend (kept for codebase continuity):
//   FE BETS_FILTER       <-> BE BET_FILTER_ENUM
//   FE BOOKMAKER_FILTER  <-> BE ODDS_MATCHES_FILTER_ENUM

export enum REQUEST_TYPE {
  RESET_BANKROLL = "resetBankRoll",
}

export enum REQUEST_STATUS {
  OPEN = "Open",
  DONE = "Done",
}

export enum NOTIFICATION_TYPE {
  ANNOUNCEMENT = "announcement",
  USER_TICKET_CREATED = "followingUserTicketCreated",
  RESET_BANKROLL = "resetBankRoll",
  RESOLVED_REQUEST = "resolvedRequest",
}

export enum USER_ORDER_BY {
  PROFIT = "PROFIT",
  ROI = "ROI",
  YIELD = "YIELD",
}

export enum BETS_FILTER {
  LATEST = "latest",
  FOLLOWING = "following",
  WINNERS = "winners",
}

export enum BOOKMAKER_FILTER {
  COMPARISON = "comparison",
  UNIBET = "unibet",
  SUPERBET = "superbet",
  BETANO = "betano",
  BETFAIR = "betfair",
  SPORT888 = "888sport",
}

export enum SPORT_ENUM {
  FOOTBALL = "football",
  BASKETBALL = "basketball",
  TENNIS = "tennis",
  HANDBALL = "handball",
  HOCKEY = "hockey",
  BASEBALL = "baseball",
  RUGBY = "rugby",
  AMERICANFOOTBALL = "americanfootball",
  ESPORTS = "esports",
  MMA = "mma",
  VOLLEYBALL = "volleyball",
}

export enum SPORT_ID_ENUM {
  FOOTBALL = 1,
  BASKETBALL = 9,
  TENNIS = 11,
  HANDBALL = 8,
  HOCKEY = 5,
  BASEBALL = 7,
  RUGBY = 6,
  AMERICANFOOTBALL = 10,
  ESPORTS = 13,
  MMA = 12,
  // 14 is our internal id. GoalServe's settlement sport number for
  // volleyball is 17 (see backend GoalServeSettlementsService) —
  // deliberately distinct; do not conflate the two.
  VOLLEYBALL = 14,
}

export enum LOGOS_SPORT_TYPES {
  SOCCER = "soccer",
  BASKETBALL = "basketball",
  BASEBALL = "baseball",
  AMFOOTBALL = "amfootball",
  HOCKEY = "hockey",
  HANDBALL = "handball",
}

export enum BET_STATE {
  WIN = "Win",
  LOOSE = "Loose",
  STAKE_REFUND = "Stake Refund",
  OPEN = "Open",
}

export enum TICKET_STATE {
  WIN = "Win",
  LOST = "Lost",
  OPEN = "Open",
  STAKE_REFUND = "Stake Refund",
}

export enum ROLES {
  ADMIN = 1384,
  USER = 2,
}

/**
 * Maps a sport name (case-insensitive, matching SPORT_ENUM values) to
 * its numeric sport id (matching SPORT_ID_ENUM values). Returns
 * `undefined` for unknown sports — callers should handle that.
 *
 * Moved here in Phase 3a from src/utils/sports.ts (which was a
 * duplicate source of truth for SPORT_ENUM). The old switch-statement
 * implementation is gone in favor of an enum lookup that keeps the
 * two enums coupled by construction.
 */
export function getSportIdByName(sportName: string): number | undefined {
  const key = sportName.toUpperCase() as keyof typeof SPORT_ID_ENUM;
  return SPORT_ID_ENUM[key];
}
